/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Row,
    CardHeader,
    Col,
    Form,
    Badge,
    Button,
    Container,
    Modal, ModalHeader, ModalBody
} from "reactstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile";
import PerfectScrollbar from "react-perfect-scrollbar";

export default function DetailPettyCash(props) {
    const token = localStorage.token;
    // const [image1, setImage1] = useState("");
    // const [image2, setImage2] = useState("");
    // const [image3, setImage3] = useState("");
    // const [image4, setImage4] = useState("");
    // const [image5, setImage5] = useState("");
    const [v, setV] = useState([])
    const [AllPettyCash, setAllPettyCash] = useState([])
    const [modalImage, setModalImage] = useState(false);
    const [bukti, setBukti] = useState("")

    useEffect(() => {
        getById();
    }, []);

    const getById = () => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/petty-cash/get/${props.match.params.id}`, { headers })
            .then((data) => {
                const res = data.data.response;
                setV(res)
                getAllDokumentPettyCash(res.id)
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getAllDokumentPettyCash = (id) => {
        let filter = {
            petty_cash_id: id,
        }
        const data = filter;
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/petty-cash/item`, data, {
            headers
        })
            .then(data => {
                setAllPettyCash(data.data.response);
            })
            .catch(function (error) {
                setAllPettyCash(error.response.data.response)
            })
    }

    const formatRupiah = (money) => {
        return new Intl.NumberFormat('id-ID',
            { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
        ).format(money);
    }


    const openImageModal = (url) => {
        setBukti(url);
        setModalImage(true);
    };

    const closeImageModal = () => {
        setModalImage(false);
    };


    return (
        <>
            <div>
                <SimpleHeaderMobile to="/mobile/pettycash/page" />
                <Container className="mt--6" fluid>
                    <>
                        <Card className="shadow mb-4">
                            <CardHeader className="bg-primary text-white">
                                <h5 className="mb-0 text-white">📄 Detail Petty Cash</h5>
                            </CardHeader>
                            <CardBody>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">Tanggal</Col>
                                    <Col xs="7">: {v.created_at}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">Kode</Col>
                                    <Col xs="7">: {v.petty_cash_code}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">Nama</Col>
                                    <Col xs="7">: {v.name}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">Request</Col>
                                    <Col xs="7">: {formatRupiah(v.nominal_request ?? 0)}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">ACC</Col>
                                    <Col xs="7">: {formatRupiah(v.nominal_approval ?? 0)}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">Dipakai</Col>
                                    <Col xs="7">: {formatRupiah(v.nominal_real ?? 0)}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs="5" className="font-weight-bold">Sisa</Col>
                                    <Col xs="7">: {formatRupiah((v.nominal_approval - v.nominal_real) ?? 0)}</Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                {AllPettyCash === null ? (
                                    <div className="d-lg-none d-xl-none">
                                        <CardHeader>
                                            <center><h3>DATA NOT FOUND</h3></center>
                                        </CardHeader>
                                    </div>
                                ) : (
                                    <Form>
                                        <PerfectScrollbar>
                                            <div
                                                className="d-lg-none d-xl-none"
                                                style={{
                                                    top: 100,
                                                    zIndex: 3,
                                                    maxHeight: "35rem",
                                                    paddingTop: "0.5rem",
                                                    overflowY: "auto", // Memastikan scrollbar berfungsi dengan baik
                                                }}
                                            >
                                                {AllPettyCash.map((v) => {
                                                    return (
                                                        <Card
                                                            key={v.id} // Pastikan setiap elemen memiliki key unik
                                                            className="mb-3 shadow border-0 bg-gradient-info"
                                                            style={{
                                                                borderRadius: "12px", // Memberikan sudut yang lebih halus
                                                                transition: "transform 0.2s ease-in-out", // Efek hover
                                                            }}
                                                            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
                                                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                                        >
                                                            <CardBody className="p-3">
                                                                <Row className="align-items-center">
                                                                    <Col>
                                                                        {/* Bagian Nominal */}
                                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                                            <h3 className="text-white mb-0 font-weight-bold">
                                                                                {formatRupiah(v.nominal)}
                                                                            </h3>
                                                                            <Button
                                                                                color="secondary"
                                                                                size="sm"
                                                                                className="btn-icon btn-sm rounded-circle"
                                                                                onClick={() => openImageModal(v.bukti_url)}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                <i className="fa fa-eye" aria-hidden="true" />
                                                                            </Button>
                                                                        </div>

                                                                        {/* Bagian Keterangan */}
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <div
                                                                                className="text-white font-weight-bold"
                                                                                style={{
                                                                                    overflow: "hidden",
                                                                                    textOverflow: "ellipsis",
                                                                                    display: "-webkit-box",
                                                                                    WebkitLineClamp: 2, // Menampilkan maksimal 2 baris teks
                                                                                    WebkitBoxOrient: "vertical",
                                                                                    fontSize: "1rem",
                                                                                }}
                                                                            >
                                                                                {v.keterangan}
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    );
                                                })}
                                            </div>
                                        </PerfectScrollbar>
                                    </Form>
                                )}
                            </CardBody>
                        </Card>
                        {/* <Row className="mt-3">
                            {[1, 2, 3, 4, 5].map((num, index) => (
                                <Col key={index} xs="6" sm="4" md="2" className="mb-3 text-center">
                                    <label htmlFor={`formId${num}`} style={{ cursor: 'pointer' }}>
                                        <input
                                            hidden
                                            id={`formId${num}`}
                                            name="file"
                                            type="file"
                                            accept="image/*"
                                            onChange={(event) => {
                                                const file = event.target.files[0];
                                                if (file) {
                                                    switch (num) {
                                                        case 1: setImage1(file); break;
                                                        case 2: setImage2(file); break;
                                                        case 3: setImage3(file); break;
                                                        case 4: setImage4(file); break;
                                                        case 5: setImage5(file); break;
                                                        default: break;
                                                    }
                                                }
                                            }}
                                        />
                                        {num === 1 && (
                                            <>
                                                {image1 === "" ? (
                                                    <img
                                                        alt="..."
                                                        src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                        width="100%"
                                                    />
                                                ) : (
                                                    <img
                                                        alt=""
                                                        src={image1}
                                                        width="100%"
                                                    />
                                                )}
                                            </>
                                        )}
                                        {num === 2 && (
                                            <>
                                                {image2 === "" ? (
                                                    <img
                                                        alt="..."
                                                        src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                        width="100%"
                                                    />
                                                ) : (
                                                    <img
                                                        alt=""
                                                        src={image2}
                                                        width="100%"
                                                    />
                                                )}
                                            </>
                                        )}
                                        {num === 3 && (
                                            <>
                                                {image3 === "" ? (
                                                    <img
                                                        alt="..."
                                                        src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                        width="100%"
                                                    />
                                                ) : (
                                                    <img
                                                        alt=""
                                                        src={image3}
                                                        width="100%"
                                                    />
                                                )}
                                            </>
                                        )}
                                        {num === 4 && (
                                            <>
                                                {image4 === "" ? (
                                                    <img
                                                        alt="..."
                                                        src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                        width="100%"
                                                    />
                                                ) : (
                                                    <img
                                                        alt=""
                                                        src={image4}
                                                        width="100%"
                                                    />
                                                )}
                                            </>
                                        )}
                                        {num === 5 && (
                                            <>
                                                {image5 === "" ? (
                                                    <img
                                                        alt="..."
                                                        src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                        width="100%"
                                                    />
                                                ) : (
                                                    <img
                                                        alt=""
                                                        src={image5}
                                                        width="100%"
                                                    />
                                                )}
                                            </>
                                        )}
                                    </label>
                                </Col>
                            ))}
                        </Row> */}
                    </>
                </Container>
                <Modal isOpen={modalImage} toggle={closeImageModal} size="lg">
                    <ModalHeader toggle={closeImageModal}>Preview Gambar</ModalHeader>
                    <ModalBody>
                        <img src={bukti} alt="preview" style={{ width: "100%", height: "auto" }} />
                    </ModalBody>
                </Modal>
            </div>
        </>
    );
}
